export const getters = {
  items: (state) => state.items,
  menu: (state) => state.selectedMenu,
  totalItems: (state) => state.totalItems,
  error: (state) => ({
    isError: state.isError,
    message: state.errorMessage,
  }),
};
